import(/* webpackMode: "eager" */ "/home/runner/actions-runner/_work/www/www/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/home/runner/actions-runner/_work/www/www/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/home/runner/actions-runner/_work/www/www/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/home/runner/actions-runner/_work/www/www/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/actions-runner/_work/www/www/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/actions-runner/_work/www/www/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/actions-runner/_work/www/www/node_modules/react-medium-image-zoom/dist/index.js");
;
import(/* webpackMode: "eager" */ "/home/runner/actions-runner/_work/www/www/src/app/partnerships/[slug]/partnership-page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/actions-runner/_work/www/www/src/components/contentful/contentful-image.tsx");
